/**
 * @file CompanyStatusBadge.tsx
 * @brief Visual badge mapping `companies.status` → variant.
 *
 * @details
 * Companies share the same lifecycle as users (active / suspended /
 * deleted) and we mirror the same colour mapping for visual consistency.
 *
 * @author DES
 * @date 26-05-2026
 */

import { Badge } from "@/components/ui/Badge";
import type { CompanyStatus } from "../schemas";

const LABEL: Record<CompanyStatus, string> = {
  active: "Active",
  suspended: "Suspended",
  deleted: "Deleted",
};

export function CompanyStatusBadge({ status }: { status: CompanyStatus }) {
  switch (status) {
    case "active":
      return <Badge variant="success">{LABEL.active}</Badge>;
    case "suspended":
      return <Badge variant="warning">{LABEL.suspended}</Badge>;
    case "deleted":
      return <Badge variant="destructive">{LABEL.deleted}</Badge>;
    default:
      return <Badge variant="muted">{String(status)}</Badge>;
  }
}
